/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.Title',
    defaultMessage: 'HUD',
  },
  hudSubsidyType: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.HUDSubsidyType',
    defaultMessage: 'HUD Subsidy Type',
  },
  eligibilityUniverseCode: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.EligibilityUniverseCode',
    defaultMessage: 'Eligibility Universe Code',
  },
  eligibilityUniverseCodePre1981: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.EligibilityUniverseCode.Pre1981',
    defaultMessage: 'Pre-1981',
  },
  eligibilityUniverseCodePost1981: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.EligibilityUniverseCode.Post1981',
    defaultMessage: 'Post-1981',
  },
  HUProjectNumber: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.HUDProjectNumber',
    defaultMessage: 'HUD Project Number',
  },
  hudSecondarySubsidyType: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.HUDSecondarySubsidyType',
    defaultMessage: 'HUD Secondary Subsidy Type',
  },
  hudContractNumber: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.HUDContractNumber',
    defaultMessage: 'HUD Contract #',
  },
  HUDCompleteGRCertsWithoutSigned59As: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.HUDCompleteGRCertsWithoutSigned59As',
    defaultMessage: 'Complete GR Certs without Signed 59As',
  },
  HUDCompleteGRCertsWithoutSigned59AsTooltip: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.HUDCompleteGRCertsWithoutSigned59AsTooltip',
    defaultMessage:
      'This setting applies to the Gross Rent tab on the Manage Certification screen.',
  },
  autoSendToTRACS: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.autoSendToTRACS',
    defaultMessage: 'Auto-send to TRACS',
  },
  autoSendToTRACSDescription: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.autoSendToTRACSDescription',
    defaultMessage:
      'When enabled, this feature automatically transmits 50059 and 50059As documents to TRACS upon cert completion. Disabling this feature requires manual document submission.',
  },
  on: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.autoSendToTRACS.on',
    defaultMessage: 'On',
  },
  off: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.autoSendToTRACS.off',
    defaultMessage: 'Off',
  },
  repaymentAgreementCollectionFee: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.repaymentAgreementCollectionFee',
    defaultMessage: 'Repayment Agreement Collection Fee %',
  },
  repaymentAgreementCollectionFeeTooltip: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.repaymentAgreementCollectionFeeTooltip',
    defaultMessage:
      'This percentage will be applied to HUD Repayment Agreements. The maximum allowed is 20%.',
  },
  valueMustNotExceed20: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.valueMustNotExceed20',
    defaultMessage: 'Value cannot exceed 20%.',
  },
  valueMustNotBeNegative: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.valueMustNotBeNegative',
    defaultMessage: 'Value must not be negative.',
  },
  contractEffectiveDate: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.contractEffectiveDate',
    defaultMessage: 'Effective Date',
  },
  contractExpirationDate: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.contractExpirationDate',
    defaultMessage: 'Expiration Date',
  },
  secondaryContractNumber: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.secondaryContractNumber',
    defaultMessage: 'HUD Secondary Subsidy Contract Number',
  },
  secondaryContractEffectiveDate: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.secondaryContractEffectiveDate',
    defaultMessage: 'Secondary Contract Effective Date',
  },
  secondaryContractExpirationDate: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.secondaryContractExpirationDate',
    defaultMessage: 'Secondary Contract Expiration Date',
  },
  expirationBeforeEffectiveDate: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.expirationBeforeEffectiveDate',
    defaultMessage: 'Expiration date cannot be before effective date.',
  },
  addContract: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.addContract',
    defaultMessage: 'Add Contract',
  },
  removeContract: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.removeContract',
    defaultMessage: 'Remove Contract',
  },
  hudMinimumRent: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.HUDMinimumRent',
    defaultMessage: 'Minimum Rent',
  },
  ownerDUNSNumber: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.OwnerDUNSNumber',
    defaultMessage: 'Owner DUNS #',
  },
  ownerDUNSNumberTooltip: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.OwnerDUNSNumberTooltip',
    defaultMessage:
      'The nine-character DUNS number assigned to the project owner. This value is reported in the TENHR record for applicable HUD programs. If the owner does not have a DUNS number, leave this field blank.',
  },
  parentCompanyDUNSNumber: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.ParentCompanyDUNSNumber',
    defaultMessage: 'Parent Company DUNS #',
  },
  parentCompanyDUNSNumberTooltip: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.ParentCompanyDUNSNumberTooltip',
    defaultMessage:
      'The nine-character DUNS number assigned to the owner’s parent company. Leave this field blank when the owner does not have a parent company.',
  },
  ownerTIN: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.OwnerTIN',
    defaultMessage: 'Owner TIN',
  },
  ownerTINTooltip: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.OwnerTINTooltip',
    defaultMessage:
      'The nine-character taxpayer identification number (TIN) for the project owner. This field is required for a TRACS submission when an owner DUNS number is provided.',
  },
  parentCompanyTIN: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.ParentCompanyTIN',
    defaultMessage: 'Parent Company TIN',
  },
  parentCompanyTINTooltip: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.ParentCompanyTINTooltip',
    defaultMessage:
      'The nine-character taxpayer identification number (TIN) for the parent company. This field is required for a TRACS submission when a parent company DUNS number is provided.',
  },
  tracsiMaxId: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.TRACSiMaxId',
    defaultMessage: 'TRACS iMAX ID',
  },
  tracsiMaxIdAlphanumericOnly: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.TRACSiMaxIdAlphanumericOnly',
    defaultMessage: 'TRACS iMAX ID may contain only letters and numbers',
  },
  tracsiMaxIdMustBeginWithTRACM: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.TRACSiMaxIdMustBeginWithTRACM',
    defaultMessage: 'TRACS iMAX ID must begin with TRACM',
  },
  tracsiMaxIdExactlyTen: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.TRACSiMaxIdExactlyTen',
    defaultMessage: 'TRACS iMAX ID must be exactly 10 characters',
  },
  caiMaxId: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.CAiMaxId',
    defaultMessage: 'CA iMAX ID',
  },
  caiMaxIdAlphanumericOnly: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.CAiMaxIdAlphanumericOnly',
    defaultMessage: 'CA iMAX ID may contain only letters and numbers',
  },
  caiMaxIdMustBeginWithTRACM: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.CAiMaxIdMustBeginWithTRACM',
    defaultMessage: 'CA iMAX ID must begin with TRACM',
  },
  caiMaxIdExactlyTen: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.CAiMaxIdExactlyTen',
    defaultMessage: 'CA iMAX ID must be exactly 10 characters',
  },
  hudProjectNumberTooltip: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.HUDProjectNumberTooltip',
    defaultMessage:
      '8-digit FHA, Elderly Housing, or State Agency noninsured project number',
  },
  hudProjectNumberExactlyEight: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.HUDProjectNumberExactlyEight',
    defaultMessage:
      'HUD Project Number must contain exactly 8 letters or numbers',
  },
  hudProjectNumberPlaceholderNotAllowed: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.HUDProjectNumberPlaceholderNotAllowed',
    defaultMessage: 'HUD Project Number cannot be the placeholder 0000FMHA',
  },
  hudProjectNumberIsPropertyId: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.HUDProjectNumberIsPropertyId',
    defaultMessage:
      'HUD Project Number looks like an iREMS Property ID. Enter it in Property ID instead',
  },
  hudProjectNumberRequired: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.HUDProjectNumberRequired',
    defaultMessage: 'HUD Project Number is required',
  },
  hudPropertyId: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.HUDPropertyId',
    defaultMessage: 'Property ID',
  },
  hudPropertyIdTooltip: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.HUDPropertyIdTooltip',
    defaultMessage:
      'Assigned by iREMS (integrated Real Estate Management System)',
  },
  hudPropertyIdDigitsOnly: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.HUDPropertyIdDigitsOnly',
    defaultMessage: 'Property ID may contain only numbers',
  },
  hudPropertyIdMaxTen: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.HUDPropertyIdMaxTen',
    defaultMessage: 'Property ID must be 10 digits or fewer',
  },
  identifierAlphanumericOnly: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.IdentifierAlphanumericOnly',
    defaultMessage: 'Only nine alphanumeric characters are allowed',
  },
  identifierExactlyNine: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.IdentifierExactlyNine',
    defaultMessage: 'Must contain exactly nine alphanumeric characters',
  },
  requiredByOwnerDUNSNumber: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.RequiredByOwnerDUNSNumber',
    defaultMessage: 'Required when Owner DUNS # is populated',
  },
  requiredByOwnerTIN: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.RequiredByOwnerTIN',
    defaultMessage: 'Required when Owner TIN is populated',
  },
  requiredByParentCompanyDUNSNumber: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.RequiredByParentCompanyDUNSNumber',
    defaultMessage: 'Required when Parent Company DUNS # is populated',
  },
  requiredByParentCompanyTIN: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.RequiredByParentCompanyTIN',
    defaultMessage: 'Required when Parent Company TIN is populated',
  },
  requiredByParentCompanyIdentifiers: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.RequiredByParentCompanyIdentifiers',
    defaultMessage: 'Required when Parent Company identifiers are populated',
  },
  ownerDUNSNumberRequiredForTRACS: {
    id: 'App.ViewProperty.AffordableSetup.Programs.HUD.OwnerDUNSNumberRequiredForTRACS',
    defaultMessage:
      'Owner DUNS # is required for TRACS submission for this subsidy type.',
  },
});

export default messages;
